import moment from 'moment';

/**
 * Форматирование даты по формату компании (company.static_date.format_string).
 * fmt — строка формата в стиле moment (напр. 'DD/MM/YYYY'); по умолчанию DD/MM/YYYY.
 * Пустое значение → ''. Некорректная дата → исходная строка (без падения UI).
 */
export const formatDate = (value?: string | Date | null, fmt?: string): string => {
  if (!value) return '';
  const f = fmt && fmt.trim() ? fmt : 'DD/MM/YYYY';
  const m = moment(value);
  return m.isValid() ? m.format(f) : String(value);
};

export default formatDate;
